
<div>
  <object-model-relationship-data
    :handler="handler"
    :q="q"
    :object-model="handler.objectModel"
    :level="1"
    :path="path"
    :parent-tree-context="computedChildTreeContext"
    @select="select"
    start-opened
  />
</div>
